// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { getType } from 'typesafe-actions';
import { ProductCard } from '../../components/NewCard/types';
import { PaginationListResponse } from '../../types/Model';
import { KeywordTitle } from '../actionCreators/search/searchLabsKeywordActions';

import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface SearchLabsState {
  labsListData: PaginationListResponse<ProductCard>;
  labsKeyword: { [key: string]: KeywordTitle[] };
  isFetching: boolean;
  isFetchingMore: boolean;
  isKeywordFetching: boolean;
  error?: Error;
  keywordError?: Error;
}

const {
  searchLabsActions,
  searchLabsKeywordActions
} = actionCreatorsList;

export const initialSearchLabsState: SearchLabsState = {
  labsListData: {
    list: [],
    totalPage: 0,
    count: 0,
    page: 0,
    limit: 0,
  },
  labsKeyword: {},
  isFetching: true,
  isFetchingMore: false,
  isKeywordFetching: true
};

export default function (state = initialSearchLabsState, action: RootAction): SearchLabsState {
  switch (action.type) {
    /** searchLabsActions will trigger when new condition is given */
    case getType(searchLabsActions.request): {
      return {
        ...state,
        isFetching: true,
        isFetchingMore: action.payload.page > 1,
        error: undefined,
      };
    }
    case getType(searchLabsActions.success): {
      const {
        list,
        totalPage,
        count,
        page,
        limit,
      } = action.payload;

      const nextList = page === 1 ? list : [...state.labsListData.list, ...list];
      return {
        ...state,
        isFetching: false,
        isFetchingMore: false,
        labsListData: {
          list: nextList,
          totalPage,
          count,
          page,
          limit,
        },
      };
    }
    case getType(searchLabsActions.failure): {
      return {
        ...state,
        isFetching: false,
        isFetchingMore: false,
        error: action.payload.error
      };
    }
    case getType(searchLabsKeywordActions.request): {
      return {
        ...state,
        isKeywordFetching: true,
        keywordError: undefined
      };
    }
    case getType(searchLabsKeywordActions.success): {
      const { name = '', list, count } = action.payload;
      const nextLabsKeyword = state.labsKeyword;
      nextLabsKeyword[name] = list;
      return {
        ...state,
        isKeywordFetching: false,
        labsKeyword: nextLabsKeyword
      };
    }
    case getType(searchLabsKeywordActions.failure): {
      return {
        ...state,
        isKeywordFetching: false,
        keywordError: action.payload.error
      };
    }

    default: {
      return state;
    }
  }
}
